import { List, ListItem, ListItemAvatar, ListItemText, Box, Typography, Tooltip, IconButton } from '@mui/material';
import { Star } from '@mui/icons-material';
import UserAvatar from './UserAvatar';

export const RankingList = ({ players, currentUserId }) => (
    <List sx={{ width: '100%' }}>
        {players.map((player, index) => (
            <ListItem
                key={player.id}
                className={`ranking-list-item ${player.id === currentUserId ? 'current-user' : ''}`}
                sx={{
                    mb: 1,
                    borderRadius: 1,
                    background: player.id === currentUserId ? 'rgba(255, 215, 0, 0.1)' : 'rgba(255, 255, 255, 0.05)',
                    '&:hover': {
                        background: player.id === currentUserId ? 'rgba(255, 215, 0, 0.15)' : 'rgba(255, 255, 255, 0.1)'
                    }
                }}
            >
                <ListItemAvatar>
                    <Box sx={{ position: 'relative' }}>
                        <UserAvatar
                            src={player.hasRpmAvatar ? player.rpmModelUrl?.replace('.glb', '.png') : player.photoURL}
                            alt={player.displayName}
                            size={40}
                            sx={{
                                border: index === 0 ? '2px solid #FFD700' :
                                    index === 1 ? '2px solid #C0C0C0' :
                                    index === 2 ? '2px solid #CD7F32' : 'none'
                            }}
                            hasRpmAvatar={player.hasRpmAvatar}
                            rpmModelUrl={player.rpmModelUrl}
                        />
                        <Typography
                            variant="caption"
                            sx={{
                                position: 'absolute',
                                top: -4,
                                left: -4,
                                width: 20,
                                height: 20,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: index === 0 ? '#FFD700' :
                                    index === 1 ? '#C0C0C0' :
                                    index === 2 ? '#CD7F32' : '#666',
                                color: '#000',
                                fontWeight: 'bold',
                                fontSize: '0.7rem',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                zIndex: 1
                            }}
                        >
                            {index + 1}
                        </Typography>
                    </Box>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    fontWeight: player.id === currentUserId ? 'bold' : 'normal',
                                    color: index <= 2 ? 'var(--color-secondary)' : 'inherit'
                                }}
                            >
                                {player.displayName}
                            </Typography>
                            {player.isGameMaster && (
                                <Tooltip title="Quizmaster" placement="top">
                                    <IconButton size="small" disableRipple sx={{ color: '#FFD700', p: 0 }}>
                                        <Star fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Box>
                    }
                    secondary={
                        <Typography variant="body2" sx={{ opacity: 0.7 }}>
                            {player.correctAnswers} richtige {player.correctAnswers === 1 ? 'Antwort' : 'Antworten'}
                        </Typography>
                    }
                />
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    minWidth: 80
                }}>
                    <Typography variant="h6" sx={{ color: 'var(--color-secondary)' }}>
                        {player.score}
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.7 }}>
                        Punkte
                    </Typography>
                </Box>
            </ListItem>
        ))}
    </List>
);